<template>
  <div v-if="content" class="optional-static-page" v-html="content"></div>
</template>

<script src="./optional-static-page.js"></script>
<style src="./optional-static-page.scss" lang="scss"></style>
